<div class="row form-row">
  <div class="col-12 mt-2">
    <div class="form-group text-start">
      <label for="currentField" class="pb-2">{{(label() + '.' + fieldName()) | translate}}
        <span *ngIf="isRequired()">*</span>:
      </label>
      <select class="form-select" id="currentField"
        (blur)="onBlur()"
        [disabled]="isDisabled()"
        [(ngModel)]="currentSelected"
        (change)="onSelectChange($event)"
        [ngClass]="{ 'is-invalid': showError || emptyOptions,
          'select-disabled': isDisabled()}"
        [required]="isRequired()">
        <option value="" *ngIf="!emptyOptions && currentSelected === ''">{{ (label() + '.select') | translate}}</option>
        <option value="" *ngIf="emptyOptions">{{ (label() + '.tableNoData') | translate}}</option>
        <option disabled="true" *ngIf="emptyOptions">{{ (label() + '.tableNoData') | translate}}</option>
        <option class="" value="{{option}}" *ngFor="let option of selectOptions(); let i = index">{{option | translate}}</option>
      </select>
      <div *ngIf="showError" class="invalid-feedback mt-2">
        <div *ngIf="isRequired() && !emptyOptions">
          {{ ('errors.' + labelError + 'Required') | translate }}
        </div>
        <div *ngIf="emptyOptions">
          {{ ('errors.' + label() + 'NotFound') | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
